import script from "./GeneEqtlTable.vue?vue&type=script&lang=js"
export * from "./GeneEqtlTable.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__